import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: 'shared-fixed-confirm-message',
    templateUrl: './fixed-confirm-message.component.html',
    styleUrl: './fixed-confirm-message.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FixedConfirmMessageComponent {
  @Input() okButtonKey?: string;
  @Input() cancelButtonKey?: string;
  @Input() isOkButtonDisabled = false;

  @Output() readonly confirmOk = new EventEmitter<void>();
  @Output() readonly confirmCancel = new EventEmitter<void>();
}
